export const getEditionsFromCollections = (collections: any[]) => {
  const editions =
    collections?.reduce((acc, collection) => {
      const ids = collection.editionIds.reduce(
        (editionsAcc, editionId) => [...editionsAcc, editionId],
        [],
      );
      return [...acc, ...ids];
    }, []) || [];
  return editions;
};
